export default "__VITE_ASSET__BT$AL0fA__"